import React from 'react';
import { Trash2 } from 'lucide-react';

export const CacheManager = () => {
  const clearCache = () => {
    if ('serviceWorker' in navigator && navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({ action: 'CLEAR_CACHE' });
      alert('Cache cleared. Refreshing in a moment...');
      setTimeout(() => window.location.reload(), 1000);
    } else {
        alert('Service Worker not available or not in control.');
    }
  };

  return (
    <div className="bg-stone-50 p-6 rounded-3xl border border-stone-200">
      <h3 className="text-sm font-black text-bark uppercase tracking-widest mb-4">Cache Management</h3>
      <p className="text-xs text-stone-500 mb-6">If documents are not loading or outdated, purge the local cache to refresh your certifications.</p>
      <div className="flex gap-4">
        <button
          onClick={clearCache}
          className="flex items-center gap-2 px-6 py-3 bg-red-50 text-red-600 rounded-xl font-black text-sm uppercase hover:bg-red-100 transition shadow-sm"
        >
          <Trash2 className="w-4 h-4" /> Purge Cache
        </button>
      </div>
    </div>
  );
};
